import React from "react";
import logo from "../images/mb-m-500-white.png";
import chessIcon from "../images/chess-solid.svg";
import nodesIcon from "../images/circle-nodes-solid.svg";
import databaseIcon from "../images/database-solid.svg";
import awsIcon from "../images/aws-brands.svg";
import audioIcon from "../images/file-audio-solid.svg";
import recordIcon from "../images/record-vinyl-solid.svg";

const services = [
  {
    icon: chessIcon,
    title: "Strategy, Product & Project Management",
    description:
      "From agency side to client side, Metabetta have seen all sides of product and project management, and have extensive experience providing detailed advice. We can build bespoke data models, analyse any of your current data or find you reliable new insights to expand your opportunities.",
  },
  {
    icon: nodesIcon,
    title: "Enterprise Architecture",
    description:
      "We specialise in Enterprise architecture and can build bespoke systems that scale. From growing and optimising consumer sites performing millions of dollars in sales per week to data and physical supply chain integration, Metabetta's cross-disciplinary experience provides unique insights into how to make your product move faster and perform more reliably.",
  },
  {
    icon: databaseIcon,
    title: "Data & Software Engineering",
    description:
      "With extensive insights gained from high-performance eCommerce websites and the largest non-streaming music data website, Metabetta can review and build bespoke software and data solutions that are designed to scale. We can do bespoke development ourselves, manage outsourced teams or find you the right 3rd party solutions.",
  },
  {
    icon: awsIcon,
    title: "AWS Architecture & DevOps",
    description:
      "Utilising 16 years of AWS experience across various businesses - everything from large scale businesses to multiple startups, Metabetta have experience in designing, building and optimising on AWS across the full stack.",
  },
  {
    icon: audioIcon,
    title: "Music Industry Consulting",
    description:
      "With detailed experience in music industry processes and data standards, and access to the largest supply of data from across the music industry, Metabetta can offer insight born of experience when it comes to processing and organising solutions at scale. A DDEX member with hands-on experience building big data systems from scratch, we understand how systems fit together and what the bug bears are for the industry.",
  },
  {
    icon: recordIcon,
    title: "Metabetta L.E.T. & the Metabetta database",
    description:
      'Our proprietary Metabetta L.E.T. (Load, Extract, Transform) software utilises an innovative hybrid Document and Relational database to ensure our clients can access the files they\'ve been sent without ever having to leave their comfort of their database.',
  },
];

export default function Services() {
  return (
    <section id="services" className="bg-primary-animated text-gray-100 py-20 md:py-24 px-8">
      <div className="max-w-screen-lg mx-auto">
        {/* Header */}
        <div className="flex flex-col items-center text-center mb-10">
          <img src={logo} alt="" className="w-8 mb-4" />
          <h2 className="text-4xl font-black">Our Services</h2>
          <p className="mt-4 text-gray-300 max-w-2xl">
            Metabetta offers 360 degree consultancy across Data Science, Software Development, Project and Product
            Management. Speak to the person that does the engineering and get insight borne of experience.
          </p>
        </div>

        {/* Cards grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mt-10">
          {services.map((service, i) => (
            <div key={i} className="flex flex-col items-center sm:items-start text-center sm:text-left px-2 py-8">
              <span className="bg-gray-100 rounded-full p-5 inline-flex items-center justify-center">
                <img src={service.icon} alt="" className="w-6 h-6" />
              </span>
              <h3 className="mt-6 font-bold text-xl tracking-wider">{service.title}</h3>
              <p className="mt-2 text-gray-400 leading-snug">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
